import axios from 'axios'
import SearchUrlBuilder from '@/core/utils/SearchUrlBuilder'

class GaleriaApiClient {

    async buscarMidias(filtros, paginacao) {
        const url = SearchUrlBuilder.buildAvanced(
            '/galeria-paciente',
            filtros,
            paginacao
        )
        return axios.get(url)
    }

    async enviar(dados) {
        const formData = new FormData()
        formData.append('arquivo', dados.arquivo)
        return axios.post(`/galeria-paciente/upload/${dados.idPaciente}`, formData)
    }


    async excluir(id) {
        return axios.delete(`/galeria-paciente/deletar/${id}`)
    }

    async gerarTokenQRCode(pacienteId) {
        return axios.post(`/galeria-paciente/gerar-token-qrcode/${pacienteId}`)
    }

    async enviarMidiaPublicToken(dados) {
        const formData = new FormData()
        formData.append('token', dados.token)
        formData.append('arquivo', dados.arquivo)
        return axios.post('/galeria-paciente/public/upload', formData, {
            headers: {
                skipAuth: true
            }
        })
    }
}

export default new GaleriaApiClient()
